import famousBabyModelChange from './actions/famousBabyModelChange';
import famousBabyModelCreate from './actions/famousBabyModelCreate';
import famousBabyModelDetail from './actions/famousBabyModelDetail';
import famousBabyModelList from './actions/famousBabyModelList';
import famousBabyModelListUpload from './mutations/famousBabyModelListUpload';
import getFamousBabyModelItems from './getters/getFamousBabyModelItems';

const actions = {
  famousBabyModelChange,
  famousBabyModelCreate,
  famousBabyModelDetail,
  famousBabyModelList,
};

const mutations = {
  famousBabyModelListUpload
};

const getters = {
  getFamousBabyModelItems
}

export default { actions, mutations, getters}